import React from 'react';
import { BsBoxArrowInLeft, BsBoxArrowInRight } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import TableArea from '../TableArea';
import { ButtonsContainer, Message } from './styles';

const ListResults: React.FC = () => {
  const {
    handleReturnCurrentStep,
    numberPerPage,
    currentPage,
    setCurrentPage,
    getListPlatesPerPage,
  } = useSteps();
  async function handleNextPage() {
    setCurrentPage(currentPage + 1);
    getListPlatesPerPage();
  }

  async function handlePreviousPage() {
    if (currentPage === 1) {
      return;
    }
    setCurrentPage(currentPage - 1);
    getListPlatesPerPage();
  }
  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        voltar
      </GoBack>
      <Title>Relação de Veículos</Title>
      <Message>
        Mostrando {numberPerPage} Placas da página {currentPage}
      </Message>

      <TableArea />

      <ButtonsContainer>
        <Button
          title="Página Anterior"
          onClick={handlePreviousPage}
          icon={BsBoxArrowInLeft}
        />
        <Button
          title="Próxima Página"
          onClick={handleNextPage}
          icon={BsBoxArrowInRight}
        />
      </ButtonsContainer>
    </Content>
  );
};

export default ListResults;
